import { ACCOUNT_STATUS_ACTIVE } from './core.constants';

/**
 * Mirrors backend `AppUser.IsActiveAccount()` — use wherever the old `isActive === true` applied to app users.
 *
 * `AppUser.status` is one of: Active | Inactive | Revoked | Pending (see `ACCOUNT_STATUS_*` in core.constants).
 * Only **Active** returns true; all other statuses (and missing/unknown status) are not active.
 *
 * @param {object | null | undefined} appUser — `/api/appuser` payload (or equivalent)
 * @returns {boolean}
 */
export default function isActiveAccount(appUser) {
  if (!appUser) {
    return false;
  }
  return appUser.status === ACCOUNT_STATUS_ACTIVE;
}
